import {
  InstantSearch,
  InstantSearchProps,
  connectStateResults,
} from 'react-instantsearch-dom';

import { logError } from '@/imports/logging/ClientLogger';

const ErrorLogger = connectStateResults(({ error }) => {
  if (!!error) {
    logError(error);
  }

  return null;
});

export const InstantSearchWithErrorLogging: React.FC<InstantSearchProps> = ({
  children,
  searchClient,
  ...instantSearchProps
}) => {
  if (!searchClient) {
    return null;
  }

  return (
    <InstantSearch searchClient={searchClient} {...instantSearchProps}>
      <ErrorLogger />
      {children}
    </InstantSearch>
  );
};
